import { render } from "./UsersIcon.vue?vue&type=template&id=4af324f7"
import script from "./UsersIcon.vue?vue&type=script&lang=js"
export * from "./UsersIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__